import hoc, { IconProps } from 'bloko/blocks/icon/hoc';

const CompanysLifeScaleMediumKindDefault = hoc(
    (props: IconProps) => (
        <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g>
                <path
                    d="M23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.7668 15.8001H11.6334L8.70002 18.0001V15.8001H7.23334C6.82833 15.8001 6.5 15.4718 6.5 15.0668V7.73334C6.5 7.32833 6.82833 7 7.23334 7H16.7668C17.1718 7 17.5001 7.32833 17.5001 7.73334V15.0668C17.5001 15.4718 17.1718 15.8001 16.7668 15.8001Z"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.8428 10.1778C10.6591 9.80383 10.2787 9.56689 9.86207 9.56689C9.44543 9.56689 9.06506 9.80383 8.88135 10.1778"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.2399 10.1778C15.0562 9.80383 14.6758 9.56689 14.2592 9.56689C13.8425 9.56689 13.4622 9.80383 13.2784 10.1778"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.1677 12.8667C11.2403 13.8446 12.8812 13.8446 13.9537 12.8667"
                    stroke="var(--bloko-icon-color, var(--bloko-icon-color-default))"
                    strokeWidth={1.5}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    ),
    'Companys'
);
export default CompanysLifeScaleMediumKindDefault;
